export default function msToDateTime(ms) {
	return new Date(ms).toISOString().replace(/T/, " ").replace(/\..+/, "");
}
